export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./printer.vue?vue&type=template&id=2ae794b7"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/printer/printer.vue?vue&type=template&id=2ae794b7
// module id = X+/h
// module chunks = 0